module.exports = __webpack_public_path__ + "static/uber-a2cee62ea2bad0a43c90d7e11f78a026.jpg";